import { render, staticRenderFns } from "./EditZone.vue?vue&type=template&id=de88b9f0&scoped=true"
import script from "./EditZone.vue?vue&type=script&lang=js"
export * from "./EditZone.vue?vue&type=script&lang=js"
import style0 from "./EditZone.vue?vue&type=style&index=0&id=de88b9f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de88b9f0",
  null
  
)

export default component.exports